import { render, staticRenderFns } from "./TextareaAndLabel.vue?vue&type=template&id=1da99b0e&"
import script from "./TextareaAndLabel.vue?vue&type=script&lang=js&"
export * from "./TextareaAndLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports